<template>
  <div class="flexwrap centercenter">
    <div class="descriptionTable">
      <div></div>
      <div class="columnProperties topRow">Gratuit</div>
      <div class=" topRow premium">Premium <i class="fas fa-burn flamme"></i></div>


      <div>Nombre de sessions par jour</div>
      <div class="columnProperties freeColumn">1</div>
      <div class="premiumColumn premiumBorderTop olive">Illimité</div>


      <div class="premiumBorderTop">Nombre de mots par épisode</div>
      <div class="columnProperties freeColumn premiumBorderTop">10</div>
      <div class="premiumColumn premiumBorderTop olive">30</div>


      <div class="premiumBorderTop">Sessions de révision</div>
      <div class="columnProperties freeColumn premiumBorderTop"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="premiumColumn premiumBorderTop olive"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>


      <div class="premiumBorderTop">Questions de compréhension (sur des séries séléctionnées)</div>
      <div class="columnProperties freeColumn premiumBorderTop"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="premiumColumn premiumBorderTop olive"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>


      <div class="premiumBorderTop">Jeu du pendu</div>
      <div class="columnProperties freeColumn premiumBorderTop bottomRow"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="premiumColumn premiumBorderTop olive bottomRow"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>
      <!--

      <div></div>
      <div class="columnProperties topRow" :class="{'freeColumnHeader':isPremium}">Gratuit</div>
      <div class="columnProperties topRow " :class="{'premiumColumnHeader':!isPremium}">Premium <i class="fas fa-burn" style="font-size: 0.9em; margin-left: 0.3vw"></i></div>


      <div>Nombre de sessions par jour</div>
      <div class="columnProperties freeColumn" :class="{'selected':isPremium}">1</div>
      <div class="columnProperties premiumColumn" :class="{'selected':!isPremium}">Illimité</div>


      <div class="premiumBorderTop">Nombre de mots par épisode</div>
      <div class="columnProperties freeColumn premiumBorderTop" :class="{'selected':isPremium}">10</div>
      <div class="columnProperties premiumColumn premiumBorderTop" :class="{'selected':!isPremium}">30</div>


      <div class="premiumBorderTop">Sessions de révision</div>
      <div class="columnProperties freeColumn premiumBorderTop" :class="{'selected':isPremium}"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="columnProperties premiumColumn premiumBorderTop" :class="{'selected':!isPremium}"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>


      <div class="premiumBorderTop">Questions de compréhension (sur des séries séléctionnées)</div>
      <div class="columnProperties freeColumn premiumBorderTop" :class="{'selected':isPremium}"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="columnProperties premiumColumn premiumBorderTop" :class="{'selected':!isPremium}"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>


      <div class="premiumBorderTop">Jeu du pendu</div>
      <div class="columnProperties freeColumn premiumBorderTop bottomRow" :class="{'selected':isPremium}"><i class="fas fa-times-circle" style="font-size: 0.9em"></i></div>
      <div class="columnProperties premiumColumn premiumBorderTop bottomRow" :class="{'selected':!isPremium}"><i class="fas fa-check-circle" style="font-size: 0.9em"></i></div>
-->
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
name: "freeVsPremium",
  props: {
    isPremium: Boolean
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },
}
</script>

<style scoped>
  .descriptionTable {
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    box-sizing: border-box;
    grid-column-gap: 0.2vw;
    padding: 1vw;
  }

  .descriptionTable > * {
    padding: 0.2vw 0.5vw 0.2vw 0.5vw;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .columnProperties{
    background-color: rgba(76,76,76,0.27);
    text-align: center;
    justify-content: center;
  }

  .premiumBorderTop{
    border-top: 0.05vw rgba(215, 164, 132, 0.27) solid;
  }

  .freeColumn{
    /*color: #ffc4c5;*/
  }

  .premiumColumn{
    /*color: var(--learnColor);*/
    font-size: 1.2em;
    text-align: center;
    justify-content: center;
    background-color: var(--goalBackgroundColor);
  }


  .selected{
    background-color: var(--goalBackgroundColor);
    color: var(--goalColor);
    border-color: rgba(215, 164, 132, 0.27);
  }

  .premiumColumnHeader {
    color: var(--goalColor);
    background-color: hsl(200, 20%, 10%);
    font-weight: bold;
  }

  .freeColumnHeader {
    color: var(--goalColor);
    background-color: var(--goalBackgroundColor);
    font-weight: bold;
  }

  .topRow{
    min-width: max-content;
    font-weight: bold;
    border-radius: 0.5vw 0.5vw 0 0;
  }

  .flamme{
    font-size: 0.9em;
    margin-left: 0.3vw
  }
  .bottomRow{
    border-radius: 0 0 0.5vw 0.5vw;
  }

  @media screen and (max-device-width: 767px) {
    .descriptionTable {
      grid-column-gap: 0.8vw;
      padding: 2vw;
    }
    .topRow{
      border-radius: 2vw 2vw 0 0;
    }

    .flamme{
      margin-left: 1vw
    }
    .bottomRow{
      border-radius: 0 0 2vw 2vw;
    }
    .descriptionTable > * {
      padding: 0.8vw 2vw 0.8vw 2vw;
    }

  }

</style>